/* 竹村商会「車種から探す」tkf-fitment-search.js
   ・適合データは window.TKF_DATA.truck（assets/tkf-fitment-data-truck.js）。乗用車は window.TKF_DATA.car が読み込まれたときだけ選べる
   ・商品名・画像・価格・在庫・バリエーションは Shopify の商品情報（/products/<handle>.js）から読む。バリエーションIDは固定で持たない
   ・適合で決まる選択肢（例：ピン角 150度）があるときだけ、その選択肢を満たすバリエーションを選んだ状態で商品ページへ進む
   ・外部ライブラリなし。すべての要素は .tkf の中だけを操作する */
(function () {
  'use strict';
  var TYPES = [{ id: 'truck', label: 'トラック' }, { id: 'car', label: '乗用車' }];
  var ST = { ok: '適合商品あり', cond: '条件付きで適合', multi: '仕様により電球規格が異なります', lamps: 'ランプが複数あります', oem: '純正LED（交換不可）', none: '対応商品なし' };
  var MAKER_HINT = 'メーカーを選んでください';

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function role(i) { return i === 0 ? 'おすすめ' : (i < 3 ? '代替商品' + i : 'その他の対応商品'); }
  function yen(cents) { return Math.round(cents / 100).toLocaleString('ja-JP') + '円'; }
  function imgUrl(u, w) { if (!u) return ''; if (u.indexOf('//') === 0) u = 'https:' + u; return u + (u.indexOf('?') >= 0 ? '&' : '?') + 'width=' + w; }

  var productCache = {};
  function getProduct(base, h) {
    if (!productCache[h]) {
      productCache[h] = fetch(base + 'products/' + encodeURIComponent(h) + '.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    }
    return productCache[h];
  }

  /* 適合で決まる選択肢 o=[名前, 値] を満たすバリエーション（在庫ありを優先）。見つからなければ null */
  function pickVariant(p, o) {
    var names = (p.options || []).map(function (x) { return typeof x === 'string' ? x : x.name; });
    if (!o) return { list: p.variants, idx: -1, v: null };
    var idx = names.indexOf(o[0]);
    if (idx < 0) return null;
    var key = 'option' + (idx + 1);
    var ms = p.variants.filter(function (v) { return v[key] === o[1]; });
    if (!ms.length) return null;
    var av = ms.filter(function (v) { return v.available; });
    return { list: ms, idx: idx, v: av[0] || ms[0] };
  }

  function init(el) {
    var base = el.getAttribute('data-root') || '/';
    if (base.charAt(base.length - 1) !== '/') base += '/';
    var $ = function (s) { return el.querySelector(s); };
    var selMk = $('[data-tkf-mk]'), selMd = $('[data-tkf-md]'), selGn = $('[data-tkf-gn]'), selPs = $('[data-tkf-ps]');
    var out = $('[data-tkf-out]');
    var sels = [selMk, selMd, selGn, selPs];

    /* 選択欄：長い車種名・年式名も全文が見えるよう、選んだ文字を折り返して表示する（操作は元の select のまま） */
    sels.forEach(function (s) {
      var box = document.createElement('div');
      box.className = 'tkf-sel';
      s.parentNode.insertBefore(box, s);
      box.appendChild(s);
      var face = document.createElement('span');
      face.className = 'tkf-sel__face';
      face.setAttribute('aria-hidden', 'true');
      box.appendChild(face);
    });
    function syncSel() {
      sels.forEach(function (s) {
        var o = s.options[s.selectedIndex], face = s.parentNode.querySelector('.tkf-sel__face');
        face.textContent = '';
        /* 「年式　グレード　型式」のような全角スペース区切りは、区切りごとにまとめて折り返す */
        (o ? o.text : '').split('　').forEach(function (part, i) {
          if (i) face.appendChild(document.createTextNode('　'));
          var sp = document.createElement('span');
          sp.className = 'tkf-sel__seg';
          sp.textContent = part;
          face.appendChild(sp);
        });
        s.parentNode.className = 'tkf-sel' + (s.disabled ? ' is-disabled' : '') + (s.value === '' ? ' is-empty' : '');
      });
    }
    var store = window.TKF_DATA || {};
    var type = 'truck';
    var uid = 0;

    /* 車両区分：データが読み込まれた区分だけ選べる（乗用車は準備中） */
    Array.prototype.forEach.call(el.querySelectorAll('[data-type]'), function (b) {
      var t = b.getAttribute('data-type');
      var ready = !!(store[t] && store[t].makers && store[t].makers.length);
      b.disabled = !ready;
      if (!ready && !b.querySelector('span')) b.insertAdjacentHTML('beforeend', '<span>準備中</span>');
      if (ready && b.querySelector('span')) b.removeChild(b.querySelector('span'));
      b.addEventListener('click', function () {
        if (b.disabled || type === t) return;
        type = t; setPressed(); fillMakers(); clearBelow(selMk); render(); saveHash();
      });
    });
    function setPressed() { Array.prototype.forEach.call(el.querySelectorAll('[data-type]'), function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-type') === type ? 'true' : 'false'); }); }

    function data() { return store[type] || { makers: [] }; }
    function fill(sel, items, hint) {
      sel.innerHTML = '<option value="">' + esc(hint) + '</option>' + items.map(function (x, i) { return '<option value="' + i + '">' + esc(x) + '</option>'; }).join('');
      sel.disabled = !items.length;
    }
    function maker() { return selMk.value === '' ? null : data().makers[+selMk.value]; }
    function model() { var m = maker(); return m && selMd.value !== '' ? m.models[+selMd.value] : null; }
    function gen() { var d = model(); return d && selGn.value !== '' ? d.gens[+selGn.value] : null; }
    function fillMakers() { fill(selMk, data().makers.map(function (m) { return m.n; }), MAKER_HINT); }
    function clearBelow(sel) {
      if (sel === selMk) { fill(selMd, [], 'メーカーを選んでください'); }
      if (sel === selMk || sel === selMd) { fill(selGn, [], '車種を選んでください'); }
      fill(selPs, [], '年式を選んでください');
    }
    function onMaker() {
      var m = maker(); clearBelow(selMk);
      if (m) {
        fill(selMd, m.models.map(function (d) { return d.n + (d.cls ? '（' + d.cls + '）' : ''); }), '車種を選んでください');
        if (m.models.length === 1) { selMd.value = '0'; onModel(); return; }
      }
      render();
    }
    function onModel() {
      var d = model(); clearBelow(selMd);
      if (d) {
        fill(selGn, d.gens.map(function (g) { return g.n; }), '年式・世代を選んでください');
        if (d.gens.length === 1) { selGn.value = '0'; onGen(); return; }
      }
      render();
    }
    function onGen() {
      var g = gen();
      fill(selPs, [], '年式を選んでください');
      if (g) {
        selPs.innerHTML = '<option value="">すべての部位（' + g.res.length + '）</option>' + g.res.map(function (r, i) { return '<option value="' + i + '">' + esc(r.p) + '</option>'; }).join('');
        selPs.disabled = false;
      }
      render();
    }
    selMk.addEventListener('change', function () { onMaker(); saveHash(); });
    selMd.addEventListener('change', function () { onModel(); saveHash(); });
    selGn.addEventListener('change', function () { onGen(); saveHash(); });
    selPs.addEventListener('change', function () { render(); saveHash(); });

    /* ---- 表示 ---- */
    function specRows(rows) {
      return '<dl class="tkf-spec">' + rows.filter(function (x) { return x[1]; }).map(function (x) { return '<div class="tkf-spec__row"><dt>' + esc(x[0]) + '</dt><dd>' + esc(x[1]) + '</dd></div>'; }).join('') + '</dl>';
    }
    function cardHtml(c, i) {
      var o = c.o ? '<p class="tkf-card__sel" data-sel>購入時に選ぶもの：' + esc(c.o[0]) + ' ' + esc(c.o[1]) + '</p>' : '<p class="tkf-card__sel" data-sel hidden></p>';
      var href = base + 'products/' + encodeURIComponent(c.h);
      return '<article class="tkf-card' + (i === 0 ? ' is-first' : '') + '" data-h="' + esc(c.h) + '"' + (c.o ? ' data-o="' + esc(JSON.stringify(c.o)) + '"' : '') + '>' +
        '<p class="tkf-card__role">' + role(i) + '</p>' +
        '<a class="tkf-card__media" href="' + esc(href) + '" tabindex="-1" aria-hidden="true" data-link><span class="tkf-card__ph">' + esc(c.m) + '</span></a>' +
        '<div class="tkf-card__body">' +
        '<h4 class="tkf-card__model"><span>' + esc(c.m) + '</span>' + (c.v ? '<b>' + esc(c.v) + '</b>' : '') + '</h4>' +
        (c.d ? '<p class="tkf-card__label">' + esc(c.d) + '</p>' : '') +
        '<p class="tkf-card__title" data-title></p>' +
        '<p class="tkf-card__price" data-price></p>' + o +
        '<p class="tkf-card__todo" data-todo hidden></p>' +
        (c.c ? '<ul class="tkf-card__cond">' + c.c.map(function (x) { return '<li>条件：' + esc(x) + '</li>'; }).join('') + '</ul>' : '') +
        (c.a ? '<ul class="tkf-card__caut">' + c.a.map(function (x) { return '<li>注意：' + esc(x) + '</li>'; }).join('') + '</ul>' : '') +
        '<a class="tkf-card__btn" href="' + esc(href) + '" data-link>商品ページで選ぶ</a>' +
        '</div></article>';
    }
    function cardsHtml(cs) {
      if (!cs || !cs.length) return '';
      var id = 'tkf-more-' + (++uid);
      var h = '<div class="tkf-cards">' + cs.slice(0, 3).map(cardHtml).join('') + '</div>';
      if (cs.length > 3) {
        h += '<button type="button" class="tkf-more" aria-expanded="false" aria-controls="' + id + '" data-more>その他の対応商品を見る（' + (cs.length - 3) + '件）</button>' +
          '<div class="tkf-cards" id="' + id + '" hidden>' + cs.slice(3).map(function (c, j) { return cardHtml(c, j + 3); }).join('') + '</div>';
      }
      return h;
    }
    function resHtml(r) {
      var h = '<section class="tkf-res tkf-res--' + r.k + '"><header class="tkf-res__head"><h3 class="tkf-res__pos">' + esc(r.p) + '</h3><span class="tkf-st tkf-st--' + r.st + '">' + esc(ST[r.st] || '') + '</span></header>';
      if (r.k === 'single') {
        h += specRows([['純正バルブ', r.b], ['口金・規格', r.s], ['電圧', r.volt || '記載なし'], ['W数', r.w], ['ピン角', r.pin]]);
        h += r.cards ? '<p class="tkf-sub">竹村商会の対応商品</p>' + cardsHtml(r.cards) : '<p class="tkf-none">' + esc(r.msg || '') + '</p>';
      } else {
        h += specRows([['電圧', r.volt || '記載なし']]);
        h += '<div class="tkf-alert" role="note">' + (r.n || []).map(function (x) { return '<span>' + esc(x) + '</span>'; }).join('') + '</div>';
        h += (r.g || []).map(function (g) {
          return '<div class="tkf-group tkf-group--' + r.k + '"><h4 class="tkf-group__title">' + (r.k === 'multi' ? '【' + esc(g.t) + '】' : esc(g.t)) + '</h4>' +
            '<p class="tkf-group__bulb">純正バルブ：' + esc(g.b) + '</p>' +
            (g.cards ? cardsHtml(g.cards) : '<p class="tkf-none">' + esc(g.none || '') + '</p>') + '</div>';
        }).join('');
      }
      if (r.notes && r.notes.length) h += '<div class="tkf-notes"><p class="tkf-notes__title">注意事項</p><ul>' + r.notes.map(function (x) { return '<li>' + esc(x) + '</li>'; }).join('') + '</ul></div>';
      return h + '</section>';
    }
    function render() {
      syncSel();
      var m = maker(), d = model(), g = gen();
      if (!m || !d || !g) {
        out.innerHTML = '<p class="tkf-empty">' + (!m ? 'メーカー・車種・年式を選ぶと、竹村商会の対応商品が表示されます。' : (!d ? '車種を選んでください。' : '年式・世代を選んでください。')) + '</p>';
        return;
      }
      var list = selPs.value === '' ? g.res : [g.res[+selPs.value]];
      out.innerHTML = '<div class="tkf-veh"><p class="tkf-veh__name">' + esc(m.n) + '　' + esc(d.n) + (d.cls ? '（' + esc(d.cls) + '）' : '') + '</p><p class="tkf-veh__gen">' + esc(g.n) + '</p>' +
        '<p class="tkf-veh__count">' + (selPs.value === '' ? '全' + g.res.length + '部位' : '部位：' + esc(list[0].p)) + '</p></div>' + list.map(resHtml).join('');
      enhance();
    }

    /* 商品カードに Shopify の商品情報（名前・画像・価格・在庫・バリエーション）を入れる */
    function enhance() {
      Array.prototype.forEach.call(out.querySelectorAll('.tkf-card'), function (card) {
        var h = card.getAttribute('data-h');
        var o = card.getAttribute('data-o') ? JSON.parse(card.getAttribute('data-o')) : null;
        getProduct(base, h).then(function (p) {
          if (!card.isConnected) return;
          var sel = card.querySelector('[data-sel]'), todo = card.querySelector('[data-todo]');
          if (!p || !p.variants) {
            if (o) { sel.hidden = false; sel.textContent = '商品ページで「' + o[0] + '：' + o[1] + '」をお選びください'; }
            return;
          }
          var pick = pickVariant(p, o);
          var href = p.url || (base + 'products/' + h);
          var names = (p.options || []).map(function (x) { return typeof x === 'string' ? x : x.name; });
          var multiVals = (p.options || []).map(function (x) { return x && x.values ? x.values.length : 2; });
          if (pick && pick.v && o) {
            href += (href.indexOf('?') >= 0 ? '&' : '?') + 'variant=' + pick.v.id;
            sel.hidden = false; sel.textContent = '選択済み：' + o[0] + ' ' + o[1] + '（この状態で商品ページが開きます）';
          } else if (o) {
            sel.hidden = false; sel.textContent = '商品ページで「' + o[0] + '：' + o[1] + '」をお選びください';
          }
          var rest = names.filter(function (n, i) { return (!pick || i !== pick.idx) && multiVals[i] > 1 && n !== 'Title'; });
          if (rest.length) { todo.hidden = false; todo.textContent = '購入前に選択：' + rest.join('・'); }
          var vs = (pick && pick.list) || p.variants;
          var prices = vs.map(function (v) { return v.price; });
          var lo = Math.min.apply(null, prices), hi = Math.max.apply(null, prices);
          var avail = vs.some(function (v) { return v.available; });
          card.querySelector('[data-price]').innerHTML = esc(yen(lo)) + (hi > lo ? '〜' : '') + (avail ? '' : ' <span class="tkf-card__soldout">在庫切れ</span>');
          card.querySelector('[data-title]').textContent = p.title || '';
          var img = (pick && pick.v && pick.v.featured_image && pick.v.featured_image.src) || p.featured_image;
          var media = card.querySelector('.tkf-card__media');
          if (img) media.innerHTML = '<img src="' + esc(imgUrl(img, 360)) + '" alt="" loading="lazy" width="180" height="180">';
          Array.prototype.forEach.call(card.querySelectorAll('[data-link]'), function (a) { a.setAttribute('href', href); });
        });
      });
    }
    out.addEventListener('click', function (e) {
      var b = e.target.closest ? e.target.closest('[data-more]') : null;
      if (!b) return;
      var box = document.getElementById(b.getAttribute('aria-controls'));
      var open = b.getAttribute('aria-expanded') !== 'true';
      box.hidden = !open; b.setAttribute('aria-expanded', open ? 'true' : 'false');
      b.textContent = open ? '閉じる' : 'その他の対応商品を見る（' + box.querySelectorAll('.tkf-card').length + '件）';
    });

    /* 選んだ状態を URL の # に保存（共有・戻る用。検索エンジンに出る URL は増えない） */
    function saveHash() {
      var m = maker(), d = model(), g = gen();
      var parts = [type];
      if (m) parts.push(m.n); if (d) parts.push(d.n); if (g) parts.push(g.n);
      if (g && selPs.value !== '') parts.push(g.res[+selPs.value].p);
      var h = '#' + parts.map(encodeURIComponent).join('/');
      if (history.replaceState) history.replaceState(null, '', location.pathname + location.search + h);
    }
    function readHash() {
      var parts = location.hash.replace(/^#/, '').split('/').map(function (x) { try { return decodeURIComponent(x); } catch (e) { return ''; } });
      if (parts[0] && store[parts[0]]) { type = parts[0]; setPressed(); fillMakers(); }
      var idx = function (arr, name) { for (var i = 0; i < arr.length; i++) if (arr[i] === name) return i; return -1; };
      var mi = idx(data().makers.map(function (x) { return x.n; }), parts[1]);
      if (mi < 0) return;
      selMk.value = String(mi); onMaker();
      var di = idx(maker().models.map(function (x) { return x.n; }), parts[2]);
      if (di < 0) return;
      selMd.value = String(di); onModel();
      var gi = idx(model().gens.map(function (x) { return x.n; }), parts[3]);
      if (gi < 0) return;
      selGn.value = String(gi); onGen();
      var pi = idx(gen().res.map(function (x) { return x.p; }), parts[4]);
      if (pi >= 0) { selPs.value = String(pi); render(); }
    }

    /* テーマのヘッダーがページの上に重なる作りのとき、見出しが隠れないよう余白を足す */
    var hdrSel = el.getAttribute('data-header-selector') || '';
    function fitHeader() {
      var hd = hdrSel ? document.querySelector(hdrSel) : null, off = 0;
      if (hd) {
        var pos = getComputedStyle(hd).position;
        if (pos === 'absolute' || pos === 'fixed') off = Math.max(0, Math.round(hd.getBoundingClientRect().bottom - el.getBoundingClientRect().top));
      }
      el.style.setProperty('--tkf-head-offset', off + 'px');
    }
    if (hdrSel) {
      fitHeader();
      var fitT; window.addEventListener('resize', function () { clearTimeout(fitT); fitT = setTimeout(fitHeader, 120); });
      window.addEventListener('load', fitHeader);
    }

    setPressed(); fillMakers(); clearBelow(selMk); render();
    if (location.hash.length > 1) readHash();
  }

  function start() { Array.prototype.forEach.call(document.querySelectorAll('[data-tkf]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
